import React from "react";
import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { COMPANY } from "@/i18n";
import { Reveal, MaskLines } from "./Reveal";

export const Supply = () => {
  const { t } = useLang();
  const s = t.supply;

  return (
    <section id="supply" data-testid="supply-section" className="relative py-24 sm:py-32 bg-[#0A0A0B] border-y border-white/10">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        <div>
          <Reveal>
            <p className="font-mono text-xs sm:text-sm uppercase tracking-[0.25em] text-[#D4AF37] mb-6">
              {s.overline}
            </p>
          </Reveal>
          <h2 className="font-display font-medium tracking-tighter text-4xl sm:text-5xl lg:text-6xl leading-[1.02] text-white">
            <MaskLines lines={[s.title]} />
          </h2>
          <Reveal delay={0.15}>
            <p className="mt-6 text-lg text-zinc-400 max-w-lg">{s.lead}</p>
          </Reveal>

          <div className="mt-10 grid sm:grid-cols-2 gap-x-8 gap-y-4">
            {s.items.map((item, i) => (
              <Reveal key={i} delay={i * 0.05}>
                <div className="flex items-center gap-3 group">
                  <span className="flex items-center justify-center w-6 h-6 rounded-full bg-[#1E5631]/30 border border-[#2E8B57]/40 text-[#2E8B57] shrink-0 group-hover:bg-[#D4AF37] group-hover:text-black group-hover:border-[#D4AF37] transition-colors">
                    <Check size={13} strokeWidth={3} />
                  </span>
                  <span className="text-zinc-200 text-sm sm:text-base">{item}</span>
                </div>
              </Reveal>
            ))}
          </div>
        </div>

        <Reveal delay={0.1}>
          <div className="relative">
            <div className="absolute -inset-3 rounded-3xl bg-gradient-to-tr from-[#D4AF37]/20 to-transparent blur-2xl" />
            <div className="relative rounded-2xl overflow-hidden border border-white/10 aspect-[4/5]">
              <img
                src={COMPANY.photos.exterior}
                alt="Poslovni objekat Kruška Distribucija u Kruševcu"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" />
              <div className="absolute bottom-6 left-6 right-6">
                <p className="font-mono text-xs uppercase tracking-widest text-[#D4AF37]">B2B</p>
                <p className="font-display text-xl font-semibold text-white mt-1">
                  Isporuka širom Srbije
                </p>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
